export default [
  [10000, 100000000],
  [5000, 9999],
  [1000, 4999],
  [500, 999],
  [100, 499],
  [50, 99],
  [0, 49]
];
